import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Route, Router, RouterModule } from '@angular/router';
import { LayoutService, PageLayout } from '@app/layout/layout.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { isNullOrUndefined } from '@app/shared/utils';
import { lastValueFrom } from 'rxjs';
import { AccountService } from '@app/services/account.service';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-home-redirect',
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './home-redirect.component.html',
  styleUrl: './home-redirect.component.scss',
  standalone: true,
  providers: [AccountService],
  host: {
    class: 'h-100 w-100',
  },

  changeDetection: ChangeDetectionStrategy.Default,
})
export class HomeRedirectComponent implements OnInit {
  isLoading = true;
  organizations: { id: number; name: string }[] = [];

  email = 'info@forfettari-online.it';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AngularFireAuth,
    private layoutService: LayoutService,
    private accountService: AccountService,
    private changeDetectorRef: ChangeDetectorRef, // changeDetectorRef.markForCheck()
  ) {}

  // private router = inject(Router);

  ngOnInit(): void {
    // Redirect to the home page
    this.isLoading = true;
    this.changeDetectorRef.markForCheck();
    this.auth.user.subscribe({
      next: (currentUser) => {
        if (isNullOrUndefined(currentUser)) {
          let pageL: PageLayout = PageLayout.UnAuthorized;
          this.layoutService.setLayout(pageL);
          this.changeDetectorRef.markForCheck();
          this.router.navigate(['/auth/login']);
        } else {
          this.accountService.getUserDetail().subscribe({
            next: (djUser) => {
              if (djUser) {
                this.organizations = djUser.organizations;
                if (this.organizations.length == 1) {
                  // If the user has only one organization, redirect to the dashboard of that organization
                  this.layoutService.setOrganizationId(
                    this.organizations[0].id,
                  );
                  this.layoutService.setOrganizationName(
                    this.organizations[0].name,
                  );
                  this.layoutService.setLayout(PageLayout.Authorized);
                  this.router.navigate([
                    '/',
                    this.organizations[0].id,
                    'dashboard',
                  ]);
                }
              } else {
                this.organizations = [];
                console.error('User not found');
              }
              this.isLoading = false;
              this.changeDetectorRef.markForCheck();
            },
            error: (err) => {
              this.isLoading = false;
              this.changeDetectorRef.markForCheck();
              console.error('Error fetching user details:', err);
              this.router.navigate(['/auth/logout']);
            },
          });
          // User is authenticated, set the layout to Authorized

          // let pageL: PageLayout = PageLayout.Authorized;
          // this.layoutService.setLayout(pageL);
          // await pageL = lastValueFrom(this.layoutService.layout$);
          // if (pageL === PageLayout.Authorized) {
          //   this.router.navigate(['/', 'dashboard']);
          //   return;
          // }
        }
      },
      error: (error) => {
        console.error('Error fetching current user:', error);
        this.isLoading = false;
        this.layoutService.setLayout(PageLayout.UnAuthorized);
        this.changeDetectorRef.markForCheck();
        this.router.navigate(['/auth/login']);
      },
    });
  }

  bookCallRedirect() {
    window.open('https://www.beizy.it/contatti', '_blank');
    // or window.location.href = 'https://your-external-link.com';
  }

  goToLogout(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/auth/logout`]);
  }
}
